module.exports = __webpack_public_path__ + "static/media/play-boss-4.b8137bef.png";